import { useInfiniteQuery } from "@tanstack/react-query"
import { useArticleFilterStore } from "../stores/useArticleFilterStore"
import { brandFilterApi } from "../api/filtersQuery/filterApi"
import { useIntersection } from "./useIntersection";
import { useSearchParams } from "react-router";
import { Loader } from "../module/brand-filter/components/select/loader";


export function useArticleFilter() {
    const [searchParams] = useSearchParams()
    const { enabled, setCategory_id, toggleEnabled, category_id } = useArticleFilterStore();

    const { data: oemProducts, fetchNextPage, isFetchingNextPage, hasNextPage, isLoading } = useInfiniteQuery({ ...brandFilterApi.getProductsByOEMInfinite(searchParams.get('part_number'), searchParams.get('category_id')) })
    // const { data: oemProducts } = useQuery({ ...brandFilterApi.getProductsByOEM(enabled, category_id) })
    const intersectRef = useIntersection(() => {



        if (hasNextPage) {

            fetchNextPage()
        }


    })

    // const intersectRef = useIntersection(() => {


    //     if (hasNextPage) {
    //         fetchNextPage()
    //     }



    // })
    const IntersectElement = () => (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: '20px', width: '100%' }} ref={intersectRef}>
            {isLoading && <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} > <Loader /> </div>}
            {isFetchingNextPage && <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} > <Loader /> ddd</div>}
        </div>
    );
    return { setCategory_id, enabled, toggleEnabled, oemProducts, IntersectElement, isLoading, isFetchingNextPage }
}

